
import { collection, query, orderBy, getDocs, limit, where } from "firebase/firestore";
import { db } from '../../firebase';
import {
    getPostTestSearchToken,
    postTestMatchesSearch,
    POST_TEST_SEARCH_FIELDS,
} from '../postTestSearch';

const getPostTimeMillis = (postTime) => {
    if (!postTime) {
        return 0;
    }

    if (typeof postTime.toMillis === 'function') {
        return postTime.toMillis();
    }

    if (postTime.seconds) {
        return postTime.seconds * 1000;
    }

    const parsedDate = new Date(postTime).getTime();
    return Number.isNaN(parsedDate) ? 0 : parsedDate;
};

const sortByNewestPostTime = (items) => {
    return [...items].sort((a, b) => getPostTimeMillis(b.postTime) - getPostTimeMillis(a.postTime));
};

const mapPostTestSnapshot = (querySnapshot) => {
    return querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
    }));
};

export const fetchPostTests = async (pageSize) => {
    const resultLimit = pageSize || 5;

    try {
        const q = query(collection(db, "postTests"),
            orderBy('postTime', 'desc'),
            limit(resultLimit));

        const querySnapshot = await getDocs(q);
        const list = mapPostTestSnapshot(querySnapshot);

        return {
            list, loaded: false, lastVisible: querySnapshot.docs[querySnapshot.docs.length - 1], firstVisible: querySnapshot.docs[0]
        }
    } catch (e) {
        console.log(e);
        return {
            list: [], loaded: false, lastVisible: null, firstVisible: null
        }
    }

};

export const searchPostTestsByTitle = async (searchTerm, pageSize) => {
    const searchToken = getPostTestSearchToken(searchTerm);
    const resultLimit = pageSize || 5;

    if (!searchToken) {
        return fetchPostTests(resultLimit);
    }

    try {
        const indexedQuery = query(
            collection(db, "postTests"),
            where(POST_TEST_SEARCH_FIELDS.keywords, 'array-contains', searchToken),
            limit(Math.max(resultLimit * 8, 50))
        );

        const indexedSnapshot = await getDocs(indexedQuery);
        const indexedMatches = sortByNewestPostTime(
            mapPostTestSnapshot(indexedSnapshot).filter((item) => postTestMatchesSearch(item, searchTerm))
        );

        if (indexedMatches.length) {
            return {
                list: indexedMatches.slice(0, resultLimit),
                loaded: false,
                lastVisible: null,
                firstVisible: null,
            };
        }

        const recentFallbackQuery = query(
            collection(db, "postTests"),
            orderBy('postTime', 'desc'),
            limit(Math.max(resultLimit * 20, 100))
        );
        const recentFallbackSnapshot = await getDocs(recentFallbackQuery);
        const fallbackMatches = mapPostTestSnapshot(recentFallbackSnapshot)
            .filter((item) => postTestMatchesSearch(item, searchTerm))
            .slice(0, resultLimit);

        return {
            list: fallbackMatches,
            loaded: false,
            lastVisible: null,
            firstVisible: null,
        };
    } catch (e) {
        console.log(e);
        return {
            list: [], loaded: false, lastVisible: null, firstVisible: null
        }
    }
};
